var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("settings-title")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12", lg: "6" } },
                [
                  _c("w-input", {
                    attrs: {
                      fancy: "",
                      label: _vm.$ct("labels.firstName"),
                      required: _vm.isOwner,
                    },
                    model: {
                      value: _vm.inputs.firstName,
                      callback: function ($$v) {
                        _vm.$set(_vm.inputs, "firstName", $$v)
                      },
                      expression: "inputs.firstName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", lg: "6" } },
                [
                  _c("w-input", {
                    attrs: {
                      fancy: "",
                      label: _vm.$ct("labels.lastName"),
                      required: _vm.isOwner,
                    },
                    model: {
                      value: _vm.inputs.lastName,
                      callback: function ($$v) {
                        _vm.$set(_vm.inputs, "lastName", $$v)
                      },
                      expression: "inputs.lastName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", lg: "12" } },
                [
                  _c("w-input", {
                    attrs: { fancy: "", label: _vm.$ct("labels.userName") },
                    model: {
                      value: _vm.inputs.userName,
                      callback: function ($$v) {
                        _vm.$set(_vm.inputs, "userName", $$v)
                      },
                      expression: "inputs.userName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", lg: "12" } },
                [
                  _c("w-input", {
                    attrs: {
                      fancy: "",
                      label: _vm.$ct("labels.phone"),
                      required: _vm.isOwner,
                    },
                    model: {
                      value: _vm.inputs.phone,
                      callback: function ($$v) {
                        _vm.$set(_vm.inputs, "phone", $$v)
                      },
                      expression: "inputs.phone",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", lg: "12" } },
                [
                  _c(
                    "w-row",
                    { attrs: { "no-margin": "" } },
                    [
                      _c("w-input", {
                        staticClass: "mr",
                        style: { flexGrow: 1, flexShrink: 1 },
                        attrs: {
                          fancy: "",
                          label: _vm.$ct("labels.email"),
                          required: _vm.isEmailRequired,
                        },
                        model: {
                          value: _vm.inputs.email,
                          callback: function ($$v) {
                            _vm.$set(_vm.inputs, "email", $$v)
                          },
                          expression: "inputs.email",
                        },
                      }),
                      _vm.emailNotActivated
                        ? _c(
                            "w-link",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$ct("verify-email"),
                                  expression: "$ct('verify-email')",
                                },
                              ],
                              staticClass: "email-not-activated-button",
                              on: {
                                click: function ($event) {
                                  return _vm.verifyEmailClicked()
                                },
                              },
                            },
                            [
                              _c("w-fa", {
                                attrs: { icon: "exclamation-circle" },
                              }),
                            ],
                            1
                          )
                        : _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.$ct("email-verified"),
                                  expression: "$ct('email-verified')",
                                },
                              ],
                              staticClass: "email-activated-circle",
                            },
                            [_c("w-fa", { attrs: { icon: "check-circle" } })],
                            1
                          ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("w-col", { attrs: { xs: "12" } }, [
                _c("img", {
                  staticClass: "profile-img",
                  attrs: { src: _vm.profileImgUrl, alt: "Profile image" },
                }),
              ]),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "w-link",
                    {
                      on: {
                        click: function ($event) {
                          _vm.changeProfilePictureModal = true
                        },
                      },
                    },
                    [
                      _c("w-fa", { attrs: { icon: "pen" } }),
                      _vm._v(
                        " " + _vm._s(_vm.$ct("change-profile-picture")) + " "
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-link",
                    {
                      staticClass: "danger-link",
                      on: {
                        click: function ($event) {
                          return _vm.deleteProfilePicture()
                        },
                      },
                    },
                    [
                      _c("w-fa", { attrs: { icon: "trash" } }),
                      _vm._v(
                        " " + _vm._s(_vm.$ct("delete-profile-picture")) + " "
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "danger",
              on: {
                click: function ($event) {
                  return _vm.logout()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("logout")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { disabled: !_vm.isValid },
              on: {
                click: function ($event) {
                  return _vm.submit()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("submit-account-settings")) + " ")]
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.changeProfilePictureModal,
            callback: function ($$v) {
              _vm.changeProfilePictureModal = $$v
            },
            expression: "changeProfilePictureModal",
          },
        },
        [
          _c("app-change-profile-picture", {
            on: {
              close: function ($event) {
                _vm.changeProfilePictureModal = false
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }